<template>
  <div class="forditas-urlap-summary pt-4">
    <div class="container">
      <div v-if="$parent.secondPartPassed">
        <h3><b>Összegzés</b></h3>
        <h5>{{quantityTypeLabel}}:</h5> <span class="color-primary big">{{karakter}}</span>
        <hr>
        <div class="ico">
          <img src="/wp-content/themes/lebe-childtheme/assets/images/ico/kosar.png" alt="">
        </div>
        <div class="ico-left">
          <h4>Ár</h4>
          <div class="color-primary big">{{ar}} FT + ÁFA</div>
        </div>
        <hr>
        <div class="ico">
          <img src="/wp-content/themes/lebe-childtheme/assets/images/ico/kapcsolat.png" alt="">
        </div>
      </div>
      <div class="ico-left mb-1e">
        <h4>Kapcsolat</h4>
        <div class="row phone">
          +36 20 974 75 71
        </div>
        <div class="row phone">
          +36 1 240 8633
        </div>
        <div class="row email">
          <a href="mailto:nonstop@fnt-forditoiroda.hu">
            nonstop@fnt-forditoiroda.hu
          </a>
        </div>
        <div class="row remark">
          Ha elakadt, nyugodtan keressen e-mailen vagy telefonon.
        </div>
      </div>
      <div v-if="$parent.secondPartPassed">
        <div class="row">
          <div class="color-primary big mb-1e">
            Teljesítés határideje: {{$parent.hatarido ? $parent.formatDeadline($parent.hatarido) : javasoltHatarido}}
          </div>
        </div>
        <button
          type="button"
          class="btn-primary mb-1e"
          style="width:100%;"
          :disabled="!$parent.validProductData || $parent.waitResponse || $parent.fileScanningError || ($parent.hataridoKategoria === 'Kérem keressen fel!')"
          @click="$parent.trackOrder();$parent.sendToWpCart()"
        >
          Megrendelés
        </button>
        <button
          type="button"
          class="btn-secondary"
          style="width:100%;"
          @click="$parent.trackOffer();$parent.addToOffer()"
          :disabled="!$parent.validProductData || $parent.waitResponse || ($parent.hataridoKategoria === 'Kérem keressen fel!')"
        >
          Árajánlat e-mailben
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ForditasSummary",
  props: [
    'ar',
    'karakter',
    'quantityType',
    'hatarido',
    'javasoltHatarido',
  ],
  computed: {
    quantityTypeLabel() {
      let
        keys = {
          karakterszam: 'Karakterek száma',
          oldalszam: 'Oldalak száma',
          darabszam: 'Darabszám'
        }
      return keys[this.quantityType];
    }
  }
}
</script>
<style lang="scss">
.forditas-urlap-summary{
  .ico{
    float: left;
    width: 38px;
  }
  .ico+.ico-left{
    margin-left: 55px;
  }
  .container{
    background: white;
  }
}
@media screen and (min-width: 1200px) {
.forditas-urlap-summary {
    position: fixed;
    z-index: 2;
  }
  //felfele görgető gomb elrejtése
  a.backtotop{
    display: none;
  }
}
</style>
